import { render, staticRenderFns } from "./AttachmentTable.vue?vue&type=template&id=da479acc&scoped=true&"
import script from "./AttachmentTable.vue?vue&type=script&lang=js&"
export * from "./AttachmentTable.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentTable.vue?vue&type=style&index=0&id=da479acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da479acc",
  null
  
)

export default component.exports